import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { BackgroundColorElement, BackgroundColorElementActive, BorderColor, GUITextBold, GUIHeadlineLight, GUIHeadlineSuffix, GUISubBox, GUIButton, GUIRow } from "./GameUIElements";
import { wrapArraySet } from "../../../../shared/helper/IterableIteratorWrapper";
import styled from "styled-components";
import { UiConstants } from "../../../data/UiConstants";
import { BsBox } from "react-icons/bs";
import { UseItemTriggerActionModel } from "../../../../shared/action/ActionModel";
import { gameStore } from "../../../stores/GameStore";
import { imageStore } from "../../../stores/ImageStore";
import { itemStore } from "../../../stores/ItemStore";
import { InventoryWindow } from "./NineSlices";
const GridItemSize = 80;
const Grid = styled.div.withConfig({
  displayName: "InventoryUI__Grid",
  componentId: "sc-b4kefv-0"
})(["display:grid;grid-template-columns:1fr 1fr 1fr;"]);
const GridItem = styled.div.withConfig({
  displayName: "InventoryUI__GridItem",
  componentId: "sc-b4kefv-1"
})(["display:flex;flex-direction:column;margin:2px;padding:4px;width:", ";height:", ";font-size:small;overflow:hidden;background-color:", ";border-radius:", ";&.selected{background-color:", ";outline:solid 2px ", ";}"], GridItemSize + "px", GridItemSize + "px", BackgroundColorElement, UiConstants.BORDER_RADIUS, BackgroundColorElementActive, BorderColor);
const ItemImage = styled.img.withConfig({
  displayName: "InventoryUI__ItemImage",
  componentId: "sc-b4kefv-2"
})(["display:flex;align-self:center;width:", ";height:", ";border:0;"], GridItemSize * 0.9 + "px", GridItemSize * 0.9 + "px");
const DescriptionBox = styled.div.withConfig({
  displayName: "InventoryUI__DescriptionBox",
  componentId: "sc-b4kefv-3"
})(["overflow-wrap:break-word;max-width:", ";margin-left:2px;"], GridItemSize * 3 + "px");
const TagContainer = styled.div.withConfig({
  displayName: "InventoryUI__TagContainer",
  componentId: "sc-b4kefv-4"
})(["margin-top:4px;display:flex;flex-direction:row;"]);
const Tag = styled.div.withConfig({
  displayName: "InventoryUI__Tag",
  componentId: "sc-b4kefv-5"
})(["font-size:small;margin-right:4px;"]);
const ItemIcon = styled(BsBox).withConfig({
  displayName: "InventoryUI__ItemIcon",
  componentId: "sc-b4kefv-6"
})(["margin-right:6px;"]);
const ItemName = styled.div.withConfig({
  displayName: "InventoryUI__ItemName",
  componentId: "sc-b4kefv-7"
})(["display:flex;flex-grow:1;align-items:center;"]);
export const InventoryUI = observer(() => {
  var _itemStore$getItem5, _itemStore$getItem6, _itemStore$getItem7;

  const {
    t
  } = useTranslation();
  const playerInventory = gameStore.gameEngine.gameState.playerInventory;
  const [selectedItemId, setSelectedItemId] = useState("");

  function hasActiveItemTrigger(itemId) {
    const nodes = UseItemTriggerActionModel.findByItemId(gameStore.gameEngine.searchActiveTriggerNodes(), itemId);
    return nodes && nodes.length > 0;
  }

  function useItem(itemId) {
    gameStore.gameEngine.handleUseItemTrigger(itemId);
  }

  function onItemClick(itemName) {
    setSelectedItemId(itemName);
  }

  return /*#__PURE__*/React.createElement(InventoryWindow, null, /*#__PURE__*/React.createElement(GUIHeadlineLight, null, t("game.inventory"), /*#__PURE__*/React.createElement(GUIHeadlineSuffix, null, "(" + playerInventory.size + ")")), /*#__PURE__*/React.createElement(GUISubBox, null, /*#__PURE__*/React.createElement(Grid, null, wrapArraySet(playerInventory).map((itemId, index) => {
    var _itemStore$getItem, _itemStore$getItem2, _itemStore$getItem3, _itemStore$getItem4;

    return /*#__PURE__*/React.createElement(GridItem, {
      key: index,
      onClick: _ => onItemClick(itemId),
      className: itemId == selectedItemId ? "selected" : ""
    }, imageStore.getImageUrl((_itemStore$getItem = itemStore.getItem(itemId)) === null || _itemStore$getItem === void 0 ? void 0 : _itemStore$getItem.itemImageId) && /*#__PURE__*/React.createElement(ItemImage, {
      src: imageStore.getImageUrl((_itemStore$getItem2 = itemStore.getItem(itemId)) === null || _itemStore$getItem2 === void 0 ? void 0 : _itemStore$getItem2.itemImageId)
    }), !imageStore.getImageUrl((_itemStore$getItem3 = itemStore.getItem(itemId)) === null || _itemStore$getItem3 === void 0 ? void 0 : _itemStore$getItem3.itemImageId) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ItemName, null, (_itemStore$getItem4 = itemStore.getItem(itemId)) === null || _itemStore$getItem4 === void 0 ? void 0 : _itemStore$getItem4.name.get(gameStore.languageKey, true))));
  }))), selectedItemId && playerInventory.has(selectedItemId) && /*#__PURE__*/React.createElement(GUISubBox, null, /*#__PURE__*/React.createElement(GUITextBold, null, " ", /*#__PURE__*/React.createElement(ItemIcon, null), (_itemStore$getItem5 = itemStore.getItem(selectedItemId)) === null || _itemStore$getItem5 === void 0 ? void 0 : _itemStore$getItem5.name.get(gameStore.languageKey, true)), /*#__PURE__*/React.createElement(DescriptionBox, null, (_itemStore$getItem6 = itemStore.getItem(selectedItemId)) === null || _itemStore$getItem6 === void 0 ? void 0 : _itemStore$getItem6.description.get(gameStore.languageKey, true), /*#__PURE__*/React.createElement(TagContainer, null, (_itemStore$getItem7 = itemStore.getItem(selectedItemId)) === null || _itemStore$getItem7 === void 0 ? void 0 : _itemStore$getItem7.tags.map((tagName, index) => /*#__PURE__*/React.createElement(Tag, {
    key: index
  }, "#" + tagName)))), hasActiveItemTrigger(selectedItemId) && /*#__PURE__*/React.createElement(GUIRow, null, /*#__PURE__*/React.createElement("div", {
    onClick: _ => useItem(selectedItemId)
  }, /*#__PURE__*/React.createElement(GUIButton, null, t("game.inventory_use_item"))))));
});